import { appStore } from '@/store';
import { logResidentialAddressEditToFPTI } from './fpti';

export const editButtonClick = (): void => {
  const { ui: uiActions } = appStore.getActions();

  logResidentialAddressEditToFPTI();

  // When clicking in the Edit button, we should always
  // have the interstitial button with Save action
  // instead of Save & Continue
  return uiActions.toggleIsResidentialAddressOpen(true);
};
